export default __webpack_public_path__ + "static/media/SLCD_Board_2010_IMG1206.44631434.jpg";